var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch mt-2 mb-2"},[_c('div',{attrs:{"data-tuerchen_embed":"","data-public_key":"ISD-Adventskalender"}})])
}]

export { render, staticRenderFns }